import '@testing-library/jest-dom';
import { fireEvent, render, screen } from '@testing-library/react';

import { Button } from './Button';

const onClickSpy = jest.fn();

describe('Button', () => {
  it('should render primary', () => {
    render(<Button variant="primary">Test Button</Button>);
    expect(screen.getByText('Test Button')).toBeInTheDocument();
  });

  it('should render secondary', () => {
    render(<Button variant="secondary">Test Button</Button>);
    expect(screen.getByText('Test Button')).toBeInTheDocument();
    expect(screen.getByText('Test Button')).toHaveClass('button--secondary');
  });

  it('should render destructive-primary', () => {
    render(<Button variant="destructive-primary">Test Button</Button>);
    expect(screen.getByText('Test Button')).toBeInTheDocument();
    expect(screen.getByText('Test Button')).toHaveClass('button--destructive-primary');
  });

  it('should render destructive-secondary', () => {
    render(<Button variant="destructive-secondary">Test Button</Button>);
    expect(screen.getByText('Test Button')).toBeInTheDocument();
    expect(screen.getByText('Test Button')).toHaveClass('button--destructive-secondary');
  });

  it('should render blank', () => {
    render(<Button variant="blank">Test Button</Button>);
    expect(screen.getByText('Test Button')).toBeInTheDocument();
    expect(screen.getByText('Test Button')).toHaveClass('button--blank');
  });

  it('should render as column', () => {
    render(
      <Button variant="primary" displayColumn>
        Test Button
      </Button>
    );
    expect(screen.getByText('Test Button')).toBeInTheDocument();
    expect(screen.getByText('Test Button')).toHaveClass('button--wide-column');
  });

  it('should render disabled', () => {
    render(
      <Button variant="primary" disabled>
        Test Button
      </Button>
    );
    const button = screen.getByText('Test Button');
    expect(button).toBeInTheDocument();
    expect(button).toHaveAttribute('disabled');
    fireEvent.click(button);
    expect(onClickSpy).toHaveBeenCalledTimes(0);
  });

  it('should call onClick when clicked', () => {
    render(
      <Button variant="primary" onClick={onClickSpy}>
        Test Button
      </Button>
    );
    const button = screen.getByText('Test Button');
    expect(button).toBeInTheDocument();
    fireEvent.click(button);
    expect(onClickSpy).toHaveBeenCalledTimes(1);
  });
});
